<template>
    <gz-auth-view-template :bc="false">
        <GZ-StaticNotification slot="notification"/>
        
        <section slot="above-content" class="gz-tabs gz-tabs__section">
            <router-link 
                to="/admin/checkups/schedule" 
                class="gz-tabs__item"
            >Календарь проверок</router-link>
            <router-link 
                to="/admin/checkups/new" 
                class="gz-tabs__item"
            >Все проверки</router-link>
        </section>

        <section slot="content">
            <router-view></router-view>
        </section>        
    </gz-auth-view-template>
</template>

<script>
export default {
    name: 'AdminCheckups'
}
</script>